import SimpleCard from 'components/SimpleCard';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import { useSelector } from 'react-redux';
import { EFFECT_LIST_BOX_UP_IN_VIEW } from 'constants/effects';
import { USER_LEVEL } from 'constants/global';
import isGestopagoCard from 'utils/isGestopagoCard';

const SimpleCardList = ({
  title = '',
  cards = [],
  startIndex = 0,
}) => {
  const { user } = useSelector((state) => state.session);
  const isComplete = user?.level === USER_LEVEL.COMPLETE;
  const visibleCards = cards.filter((card) => isComplete || !isGestopagoCard(card?.link));

  return (
    <div className='simple-card-list mb-6'>
      {title && <h3>{title}</h3>}
      <div className='lg:grid lg:grid-cols-2 lg:gap-x-3 lg:items-start'>
        {visibleCards.map((card, i) => (
          <motion.div
            key={`card-${i + startIndex}`}
            className='min-w-0'
            {...EFFECT_LIST_BOX_UP_IN_VIEW}
            custom={i}
          >
            {card.content ? card.content : (
              <SimpleCard
                key={`simple-card-${i}`}
                {...card}
              />
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
};

SimpleCardList.propTypes = {
  title: PropTypes.string,
  cards: PropTypes.array,
  startIndex: PropTypes.number,
};

export default SimpleCardList;
